// extracted by mini-css-extract-plugin
export default {"itemLink":"mob_menu_itemLink__TtHRM","buttonLink":"mob_menu_buttonLink__txDW+ mob_menu_itemLink__TtHRM"};